import { Grid } from "@material-ui/core";
import { useQuoteField } from "Quoting/components/hooks/useHandleQuoteFieldChange";
import { useQuoteFormValidation } from "Quoting/components/hooks/useQuoteFormValidation";
import { A360ProductCd } from "Quoting/models/Quoting";
import { Map as ImmutableMap } from "immutable";
import React from "react";
import { useSelector } from "react-redux";
import { ReducerState } from "rootReducer";
import { FormRowGrid, GridRowProps } from "Quoting/components/shared/GridRow";
import { QuoteFormElement } from "Quoting/components/shared/QuoteFormElement";
import { FormWrapper } from "Quoting/components/shared/QuoteFormWrapper";
import { getGPLUEligibilityBlockPropertyPaths } from '../PropertyPaths';

export const GPLUAccelDeathEligibilityBlock = () => {
  const { getQuoteFieldValue, updateQuoteFieldValue } = useQuoteField();
  const { selectedPlan, selectedCoverageIndex } = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUEligibilityBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);
  const rows: GridRowProps[] = [
    {
      rowProps: { key: 'eligibility-row-1' },
      title: 'ISSUE AGES',
      items: [
        {
          key: propertyPaths.minIssueAge,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Minimum Issue Age"
              id={propertyPaths.minIssueAge}
              value={getQuoteFieldValue(propertyPaths.minIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.minIssueAge, Number(e.target.value))}
              type="number"
              disabled
              required
            />
          ),
        },
        {
          key: propertyPaths.maxIssueAge,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Issue Through Age"
              id={propertyPaths.maxIssueAge}
              value={getQuoteFieldValue(propertyPaths.maxIssueAge)}
              onChange={e => updateQuoteFieldValue(propertyPaths.maxIssueAge, Number(e.target.value))}
              type="number"
              disabled
              required
            />
          ),
        }
      ]
    }
  ];

  return (
    <FormWrapper title="Eligibility" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
